import React from 'react';
import { Pill } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-internal/js-react-i18n';

import Classes from './MediaGroupPills.module.scss';
import type { TMediaGroupKey } from 'types/TListing';

export type TMediaGroupPillKey = TMediaGroupKey | 'video';

type MediaGroupPillsProps = {
  groupKeys: TMediaGroupPillKey[];
  activeKey?: TMediaGroupPillKey;
  onClick: (key: TMediaGroupPillKey) => void;
};

/**
 * The active state should be handled by a parent component
 */
const MediaGroupPills = ({ groupKeys, onClick, activeKey }: MediaGroupPillsProps) => {
  const { t } = useI18nContext();

  if (!groupKeys.length) {
    return null;
  }

  return (
    <nav className={Classes.pills} aria-label={t('gallery.mediaGrouping.navigationLabel')}>
      {groupKeys.map((key) => (
        <Pill
          key={key}
          onClick={() => onClick(key)}
          isActive={key === activeKey}
          translations={{
            ariaLabelDefault: t('gallery.mediaGrouping.notActive'),
            ariaLabelActive: t('gallery.mediaGrouping.active'),
          }}
        >
          {t(`gallery.mediaGrouping.groups.${key}`)}
        </Pill>
      ))}
    </nav>
  );
};

export default MediaGroupPills;
